// material-ui
import { useTheme } from '@mui/material/styles';
import logo from '../../assets/images/logo/logo.png';  
// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
   <>
       <img
                  width={50}
                  height={50}
                  src={logo}
                  alt="Logo"
        />
    </>
  );
}
